import { h, Component } from 'preact';

// eslint-disable-next-line react/prefer-stateless-function
class ShutdownIcon extends Component {
  render () {
    const { color = '#000000', size, viewbox = '0 0 60 60', className = '', onClick } = this.props;

    return (
      <svg
        className={className}
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewbox}
        width={size}
        height={size}
        onClick={onClick}
      >
        <path
          color={color}
          d="M 24.984375 1.984375 C 24.433594 1.996094 23.992188 2.449219 24 3 L 24 25 C 23.996094 25.359375 24.183594 25.695313 24.496094 25.878906 C 24.808594 26.058594 25.191406 26.058594 25.503906 25.878906 C 25.816406 25.695313 26.003906 25.359375 26 25 L 26 3 C 26.003906 2.730469 25.898438 2.46875 25.707031 2.277344 C 25.515625 2.085938 25.253906 1.980469 24.984375 1.984375 Z M 18.046875 3.140625 C 17.921875 3.136719 17.796875 3.15625 17.683594 3.195313 C 8.566406 6.253906 2 14.867188 2 25 C 2 37.691406 12.308594 48 25 48 C 37.691406 48 48 37.691406 48 25 C 48 14.867188 41.433594 6.253906 32.316406 3.195313 C 31.792969 3.019531 31.226563 3.300781 31.050781 3.824219 C 30.875 4.347656 31.15625 4.914063 31.683594 5.09375 C 40 7.882813 46 15.730469 46 25 C 46 36.609375 36.609375 46 25 46 C 13.390625 46 4 36.609375 4 25 C 4 15.730469 10 7.882813 18.316406 5.09375 C 18.78125 4.941406 19.070313 4.484375 19 4 C 18.933594 3.519531 18.53125 3.15625 18.046875 3.140625 Z"
        />
      </svg>
    );
  }
}

export default ShutdownIcon;
